import * as React from "react";

import { ValidationReductionsDto } from "core/backend/data";
import TDatetime from "components/TDatetime";
import CheckIcon from "components/checkIcon";
import { MultiSelectItem } from "components/multiselect";

interface OwnProps {
    dto: ValidationReductionsDto;
    hubs: MultiSelectItem[];
    left: number;
}
const Row = ({ dto, hubs, left }: OwnProps) => {
    const rowSpan = dto.contingencies.length == 0 ? 1 : dto.contingencies.length;
    return <>
        <tr>
            <TDatetime rowSpan={rowSpan} date={new Date(dto.dateTimeUtc)} left={left} />
            <td rowSpan={rowSpan} className="alignLeft">{dto.tso}</td>
            <td rowSpan={rowSpan} className="alignLeft">{dto.cnecName}</td>
            <td rowSpan={rowSpan} className="alignLeft">{dto.direction}</td>
            <td rowSpan={rowSpan}><CheckIcon checked={dto.isReturnedBranch} /></td>
            <td rowSpan={rowSpan}>{dto.iva}</td>
            <td rowSpan={rowSpan}>{dto.ivaShare}</td>
            <td rowSpan={rowSpan}>{dto.justification}</td>

            <td rowSpan={rowSpan} className="lineLeft">{dto.overloadedTso}</td>
            <td rowSpan={rowSpan}>{dto.overloadedName}</td>
            <td rowSpan={rowSpan}>{dto.overloadedEic}</td>
            <td rowSpan={rowSpan}>{dto.overloadedFromUct}</td>
            <td rowSpan={rowSpan}>{dto.overloadedToUct}</td>

            <td className="lineLeft alignRight">{dto.contingencies.length > 0 && "#1:"}</td>
            <td>{dto.contingencies.length > 0 && dto.contingencies[0].name}</td>
            <td>{dto.contingencies.length > 0 && dto.contingencies[0].tso}</td>
            <td>{dto.contingencies.length > 0 && dto.contingencies[0].fromUct}</td>
            <td>{dto.contingencies.length > 0 && dto.contingencies[0].toUct}</td>

            {hubs.map((hub, i) => <td className={i == 0 ? "lineLeft" : ""} style={{ top: top + "px" }} rowSpan={rowSpan} key={hub.id} >{eval("dto.coreNp_" + hub.id.toUpperCase())}</td>)}
            
            <td rowSpan={rowSpan} className="lineLeft">{dto.comment}</td>

            <td rowSpan={rowSpan} className="lineLeft"><CheckIcon checked={dto.fallbackApplied} /></td>
        </tr>
        {
            dto.contingencies.slice(1).map((c) =>
                <tr key={c.number}>
                    <td className="lineLeft alignRight">#{c.number}:</td>
                    <td>{c.name}</td>
                    <td>{c.tso}</td>
                    <td>{c.fromUct}</td>
                    <td>{c.toUct}</td>
                </tr>
            )
        }
    </>
};

export default Row;